var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._v("\n\n\tトリビア\n\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }